<template>
  <div class="integration-content">
    <div class="integration-content-card">
      <header>
        <img src="@/assets/integrations/jira.svg" alt="Jira Cloud" />
        <div class="header-text">
          <h4>Jira Cloud</h4>
          <h5>Project Management</h5>
        </div>
      </header>
      <div class="integration-content-card-body">
        <p class="description">
          JIRA is an issue and project tracking system developed by Atlassian. With JIRA integration, the following sync modes are available:
        </p>

        <h5>One-way:</h5>

        <ul>
          <li><b>Only Import</b> Import existing issues from JIRA and manually pull new issues as needed. No data is pushed back to JIRA.</li>
        </ul>

        <h5>Two-way Sync:</h5>

        <ul>
          <li><b>Manual Sync</b><br/> Push updated features to JIRA manually and pull new issues from JIRA when required.</li>
          <li><b>Auto Sync</b><br/> Automatically sync updates between features and JIRA. Enables full bidirectional synchronization for features and issues.</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'JiraCloudDescription',
};
</script>
